import api from "../../../utilidades/interceptor";

const urlApi = process.env.REACT_APP_API_KEY;

export const getAnalisisIA = async (filtros, usuario) => {
    console.log("filtros", filtros, usuario);
    const { data } = await api.post(`${urlApi}/sumaTravel/encuestas/analisis`, { ...filtros, usuario });
    return data;
};

export const getTransporteEstatus = async () => {
    try {
        const result = await api.get(`${urlApi}/sumatravel/transporte/estatus`);
        return result.data; // [{ ESTATUS: "Cotizado", ... }, ...]
    } catch (error) {
        console.log("error getTransporteEstatus", error);
    }
};

export const getEncuestasDashboard = async (params) => {
    const { data } = await api.get(`${urlApi}/sumaTravel/encuestas/dashboard`, { params });
    return data;
};
